export default __webpack_public_path__ + "static/media/filter_talent_builder.12e2d23f.svg";